import { Link } from 'react-router-dom';
import { ShieldMark } from './ShieldMark';

export function Footer() {
  return (
    <footer className="bg-forest text-cream mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <ShieldMark size={40} />
            <div className="text-2xl font-display">MowKind</div>
          </div>
          <p className="text-cream/70 max-w-md leading-relaxed">
            A volunteer network of Coastal Bend lawn care professionals caring
            for the yards of neighbors who cannot care for them alone.
          </p>
          <div className="mt-6 inline-block px-3 py-1 border border-cream/30 text-xs tracking-widest uppercase">
            501(c)(3) status pending · fiscal sponsor partnership
          </div>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-cream/50 mb-4">Get Involved</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/apply" className="hover:text-sand">Request a Mow</Link></li>
            <li><Link to="/hire" className="hover:text-sand">Support a Mowkin</Link></li>
            <li><Link to="/provider" className="hover:text-sand">Become a Mowkin</Link></li>
            <li><Link to="/volunteer" className="hover:text-sand">Volunteer a Mow</Link></li>
            <li><Link to="/about" className="hover:text-sand">Our Mission</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-cream/50 mb-4">Founders</div>
          <div className="text-sm space-y-1.5 mb-8">
            <div>
              Victoria Valentine
              <span className="text-cream/50 text-[10px] tracking-[0.15em] uppercase ml-2">Founder</span>
            </div>
            <div>
              Jonathan Peters
              <span className="text-cream/50 text-[10px] tracking-[0.15em] uppercase ml-2">Co-Founder</span>
            </div>
            <div>
              Davy Tyler
              <span className="text-cream/50 text-[10px] tracking-[0.15em] uppercase ml-2">Co-Founder</span>
            </div>
          </div>

          <div className="text-xs tracking-[0.2em] uppercase text-cream/50 mb-4">Founding Partner</div>
          <div className="text-sm">
            <div className="mb-1">Bay Area Landscape</div>
            <div className="text-cream/60">5901 La Costa, Corpus Christi, TX</div>
            <div className="text-cream/60">(361) 826-0680</div>
            <a
              href="https://www.mybayarealandscapes.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sand hover:underline mt-2 inline-block"
            >
              mybayarealandscapes.com →
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 text-xs flex items-center justify-between">
          <div className="text-cream/50">© 2026 MowKind · A community project</div>
          <div className="text-cream/50">Coastal Bend, Texas</div>
        </div>
      </div>
    </footer>
  );
}
